import { usePartialUpdateCompetitionDivisionMutation } from '../mutations';
import { CompetitionDivisionForm } from '../create/components/division-form';
import { Schema } from '../create/components/division-form.schema';
import { PageLayout } from '~/components/PageLayout/PageLayout';
import { useCompetitionDivisionQuery } from '../queries';
import { withPrivateRoute } from '~/hocs/withPrivateRoute';
import { divisionIdParamSchema } from '~/schemas';
import { useParams } from '~/hooks/useParams';
import { Fragment } from 'react/jsx-runtime';
import { useNavigate } from 'react-router';
import { toast } from 'react-toastify';

export const Page = withPrivateRoute(() => {
  const { divisionId } = useParams(divisionIdParamSchema.parse);
  const { data } = useCompetitionDivisionQuery(divisionId);
  const mutation = usePartialUpdateCompetitionDivisionMutation();
  const navigate = useNavigate();

  async function onSubmit(payload: Schema) {
    await toast.promise(
      mutation.mutateAsync({
        id: divisionId,
        payload: {
          ...payload,
        },
      }),
      {
        success: 'Lagtävlingsdivisionen har uppdaterats',
        pending: 'Uppdaterar lagtävlingsdivisionen...',
      }
    );
    navigate(-1);
  }

  if (!data) return false;

  return (
    <Fragment>
      <PageLayout.Heading text="Redigera lagtävlingsdivision" />

      <PageLayout.Section>
        <CompetitionDivisionForm
          onSubmit={onSubmit}
          isLoading={mutation.isPending}
          mode="edit"
          defaultValues={{
            name: data.name,
            competition_type: data.competition_type.id,
            age_categories: data.age_categories.map(c => c.id),
            scoring_system: data.scoring_system,
            nomination_start_date: data.nomination_start_date ?? '',
            nomination_end_date: data.nomination_end_date ?? '',
            gender: data.gender ?? 'B',
            lifters_per_team: data.lifters_per_team,
            reserve_slots: data.reserve_slots ?? 0,
            min_female_lifters: data.min_female_lifters ?? 0,
            min_male_lifters: data.min_male_lifters ?? 0,
          }}
        />
      </PageLayout.Section>
    </Fragment>
  );
});
